export var stylesOverrides = {
    h3: {
        fontSize: "3rem !important",
        lineHeight: "1.167 !important",
    },
    h4: {
        fontSize: "2.125rem !important",
        lineHeight: "1.235 !important",
    },
    h5: {
        fontSize: "1.5rem !important",
        lineHeight: "1.334 !important",
    },
    h6: {
        fontSize: "0.875rem !important",
        lineHeight: "1.57 !important",
    },
};
